import { SvgIcon } from '@material-ui/core'

export function FilterSimplifiedIcon(props) {
  return (
    <SvgIcon {...props} fill="none">
      <path
        d="M6 12H18M3 6H21M9 18H15"
        stroke="#344054"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  )
}
